export const HOURS_PER_MONTH = 173;

export const END_DATE_CURRENTLY_WORKING = "N/A";
